module.exports = __webpack_public_path__ + "img/article_button.e5b97bb9.jpg";